// extracted by mini-css-extract-plugin
module.exports = {"loginCard":"ForgotPassword_loginCard__3pmJp","logo":"ForgotPassword_logo__9pflc"};